import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState({
    d: 5,
    h: 19,
    m: 9,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          d,
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;else {
              h = 23;
              if (d > 0) d--;
            }
          }
        }
        return {
          d,
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-brand-red flex items-center justify-center gap-2 sm:gap-3 py-1 sm:py-1.5 px-3 flex-wrap" data-id="element-344">
      <span className="font-display text-[9px] sm:text-[12px] font-semibold tracking-[1.2px] sm:tracking-[1.5px] text-white uppercase" data-id="element-345">
        🔥 OFERTA ESPECIAL FINALIZA EN
      </span>
      <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-346">
        <div className="bg-black/40 text-white font-display text-[10px] sm:text-[12px] font-semibold py-0 sm:py-0.5 px-1.5 sm:px-2 rounded min-w-[24px] sm:min-w-[30px] text-center" data-id="element-347">
          {pad(timeLeft.d)}
        </div>
        <span className="text-[10px] sm:text-[12px] font-semibold text-white/80" data-id="element-348">
          :
        </span>
        <div className="bg-black/40 text-white font-display text-[10px] sm:text-[12px] font-semibold py-0 sm:py-0.5 px-1.5 sm:px-2 rounded min-w-[24px] sm:min-w-[30px] text-center" data-id="element-349">
          {pad(timeLeft.h)}
        </div>
        <span className="text-[10px] sm:text-[12px] font-semibold text-white/80" data-id="element-350">
          :
        </span>
        <div className="bg-black/40 text-white font-display text-[10px] sm:text-[12px] font-semibold py-0 sm:py-0.5 px-1.5 sm:px-2 rounded min-w-[24px] sm:min-w-[30px] text-center" data-id="element-351">
          {pad(timeLeft.m)}
        </div>
        <span className="text-[10px] sm:text-[12px] font-semibold text-white/80" data-id="element-352">
          :
        </span>
        <div className="bg-black/40 text-white font-display text-[10px] sm:text-[12px] font-semibold py-0 sm:py-0.5 px-1.5 sm:px-2 rounded min-w-[24px] sm:min-w-[30px] text-center" data-id="element-353">
          {pad(timeLeft.s)}
        </div>
      </div>
    </div>;
}